import React from "react";
import { useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "../Component/Header";
import LazyLoad from "react-lazyload";
import Footer from "../Component/Footer";
const Mission = () => {
  useEffect(() => {
    document.title = "Mission -  Gayatri International School";
  }, []);
  return (
    <>
      <Header />
      <section className="page-header-fb innerslide">
        <div className="innerslide">
          <LazyLoad>
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GISFNU/public/Images/innerslide.gif"
              className="img-fluid"
            />
          </LazyLoad>{" "}
        </div>
        <div className="page-header__inner">
          <h2>Mission</h2>
          <ul className="thm-breadcrumb list-unstyled ml-0">
            <li>
              <Link to="/HomeFr"> Home</Link>
            </li>
            <li>|</li>
            <li>The School</li>
            <li>|</li>
            <li>Mission</li>
          </ul>
        </div>
      </section>
      <section className="innerbody">
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <div className="misionbox">
                {" "}
                <div className="missionimg">
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GISFNU/public/Images/missionicn1.png"
                    className="img-fluid"
                  />{" "}
                </div>{" "}
                <div className="misiondesc">
                  <h6>
                    <b>LEARN </b>
                  </h6>{" "}
                  <p>
                    {" "}
                    Take responsibility for their learning, develop intellectual
                    curiosity and become life-long learners{" "}
                  </p>{" "}
                </div>{" "}
              </div>
            </div>
            <div className="col-md-6">
              <div className="misionbox">
                {" "}
                <div className="missionimg">
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GISFNU/public/Images/missionicn2.png"
                    className="img-fluid"
                  />{" "}
                </div>{" "}
                <div className="misiondesc">
                  <h6>
                    <b>THINK </b>
                  </h6>{" "}
                  <p> Be a creative, innovative, and logical thinkers. </p>{" "}
                </div>{" "}
              </div>
            </div>
            <div className="col-md-6">
              <div className="misionbox">
                {" "}
                <div className="missionimg">
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GISFNU/public/Images/missionicn3.png"
                    className="img-fluid"
                  />{" "}
                </div>{" "}
                <div className="misiondesc">
                  <h6>
                    <b>COMMUNICATOR </b>
                  </h6>{" "}
                  <p>
                    {" "}
                    Think, speak and write with clarity, precision and
                    imagination.{" "}
                  </p>{" "}
                </div>{" "}
              </div>
            </div>
            <div className="col-md-6">
              <div className="misionbox">
                {" "}
                <div className="missionimg">
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GISFNU/public/Images/missionicn4.png"
                    className="img-fluid"
                  />{" "}
                </div>{" "}
                <div className="misiondesc">
                  <h6>
                    <b>PERSEVERE </b>
                  </h6>{" "}
                  <p>
                    {" "}
                    Possess a tenacity to hold on to their aspirations against
                    all odds{" "}
                  </p>{" "}
                </div>{" "}
              </div>
            </div>
            <div className="col-md-6">
              <div className="misionbox">
                {" "}
                <div className="missionimg">
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GISFNU/public/Images/missionicn5.png"
                    className="img-fluid"
                  />{" "}
                </div>{" "}
                <div className="misiondesc">
                  <h6>
                    <b>LEAD </b>
                  </h6>{" "}
                  <p>
                    {" "}
                    Demonstrate ethical behavior, rational decision making and
                    exercising leadership while working with peers.{" "}
                  </p>{" "}
                </div>{" "}
              </div>
            </div>
            <div className="col-md-6">
              <div className="misionbox">
                {" "}
                <div className="missionimg">
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GISFNU/public/Images/missionicn6.png"
                    className="img-fluid"
                  />{" "}
                </div>{" "}
                <div className="misiondesc">
                  <h6>
                    <b>EMPATHISE </b>
                  </h6>{" "}
                  <p>
                    {" "}
                    Understand other's perspectives and work
                    collaboratively{" "}
                  </p>{" "}
                </div>{" "}
              </div>
            </div>
            <div className="col-md-6">
              <div className="misionbox">
                {" "}
                <div className="missionimg">
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GISFNU/public/Images/missionicn7.png"
                    className="img-fluid"
                  />{" "}
                </div>{" "}
                <div className="misiondesc">
                  <h6>
                    <b>BE DISCIPLINED </b>
                  </h6>{" "}
                  <p>
                    {" "}
                    Practice self-discipline, manage time effectively and lead a
                    healthy & balanced life.{" "}
                  </p>{" "}
                </div>{" "}
              </div>
            </div>
            <div className="col-md-6">
              <div className="misionbox">
                {" "}
                <div className="missionimg">
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GISFNU/public/Images/missionicn8.png"
                    className="img-fluid"
                  />{" "}
                </div>{" "}
                <div className="misiondesc">
                  <h6>
                    <b>BE TRUSTWORTHY </b>
                  </h6>{" "}
                  <p>
                    {" "}
                    Adhere to ethical principles at all times and adopt
                    righteous approach.{" "}
                  </p>{" "}
                </div>{" "}
              </div>
            </div>
            <div className="col-md-6">
              <div className="misionbox">
                {" "}
                <div className="missionimg">
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GISFNU/public/Images/missionicn9.png"
                    className="img-fluid"
                  />{" "}
                </div>{" "}
                <div className="misiondesc">
                  <h6>
                    <b>BE A NURTURER </b>
                  </h6>{" "}
                  <p> Discover, value and nurture talent. </p>{" "}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default Mission;
